"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
import Image from "next/image";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/free-mode";
import { ShopifyDeveloperMarquee } from "../HireShopifyDeveloper";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function CrmHero() {
  const $ = _c(43);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 1,
      y: 0
    };
    t2 = {
      duration: 0.8,
      ease
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-[#1aad6f]">Home Services App</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-[#1aad6f]">{"Fast, Secure & User-Friendly"}</span>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t0) {
    t5 = <motion.h1 initial={t0} animate={t1} transition={t2} className="font-poppins mb-6 text-[32px] font-bold leading-[1.15] text-[#0b1354] sm:text-[44px] lg:text-[60px] dark:text-white">Build an On-Demand{" "}{t3} –{" "}{t4}</motion.h1>;
    $[6] = t0;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== desktopAnimations) {
    t6 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[8] = desktopAnimations;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      opacity: 1,
      y: 0
    };
    t8 = {
      duration: 0.8,
      delay: 0.05,
      ease
    };
    $[10] = t7;
    $[11] = t8;
  } else {
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6) {
    t9 = <motion.h2 initial={t6} animate={t7} transition={t8} className="font-poppins mb-6 text-[20px] font-bold text-[#0b1354] md:text-[26px] dark:text-white">Build High-Performing Cross-Platform Apps</motion.h2>;
    $[12] = t6;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[14] = desktopAnimations;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      opacity: 1,
      y: 0
    };
    t12 = {
      duration: 0.8,
      delay: 0.1,
      ease
    };
    $[16] = t11;
    $[17] = t12;
  } else {
    t11 = $[16];
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10) {
    t13 = <motion.p initial={t10} animate={t11} transition={t12} className="mx-auto mb-0 max-w-[1260px] font-sans text-[16px] font-normal leading-[32px] text-[#8a8a9e] md:text-[17px] dark:text-gray-400">Transform the way customers book home services with a powerful, feature-rich app. At The Dezine, we specialize in developing on-demand home services platforms tailored to your business needs. From seamless booking and real-time tracking to secure payments and user-friendly interfaces—we bring your vision to life.</motion.p>;
    $[18] = t10;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== desktopAnimations) {
    t14 = desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false;
    $[20] = desktopAnimations;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      opacity: 1,
      y: 0
    };
    t16 = {
      duration: 0.7,
      delay: 0.2,
      ease
    };
    $[22] = t15;
    $[23] = t16;
  } else {
    t15 = $[22];
    t16 = $[23];
  }
  let t17;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <GradientButton href="/contact" variant="peach-pink">Get a Free Consultation{" "}<FaChevronRight className="ml-1 text-[12px]" /></GradientButton>;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t14) {
    t18 = <motion.div initial={t14} animate={t15} transition={t16} className="mt-8 md:mt-10">{t17}</motion.div>;
    $[25] = t14;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t13 || $[28] !== t18 || $[29] !== t5 || $[30] !== t9) {
    t19 = <div className="mx-auto max-w-[1200px] text-center">{t5}{t9}{t13}{t18}</div>;
    $[27] = t13;
    $[28] = t18;
    $[29] = t5;
    $[30] = t9;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== desktopAnimations) {
    t20 = desktopAnimations ? {
      opacity: 0,
      scale: 0.95
    } : false;
    $[32] = desktopAnimations;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  let t22;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      opacity: 1,
      scale: 1
    };
    t22 = {
      duration: 0.85,
      delay: 0.22,
      ease
    };
    $[34] = t21;
    $[35] = t22;
  } else {
    t21 = $[34];
    t22 = $[35];
  }
  let t23;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Image src="/images/crm/hero.png" alt="Home Services App" width={1200} height={600} priority={true} className="h-auto w-full object-contain" />;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== t20) {
    t24 = <motion.div initial={t20} animate={t21} transition={t22} className="relative mx-auto mt-8 w-full max-w-[1100px] md:mt-10">{t23}</motion.div>;
    $[37] = t20;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <ShopifyDeveloperMarquee />;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  let t26;
  if ($[40] !== t19 || $[41] !== t24) {
    t26 = <section className="relative overflow-hidden bg-[linear-gradient(180deg,#d5f7e9_0%,#e6fbf1_55%,#ffffff_100%)] pt-12 pb-10 transition-colors duration-300 sm:pt-16 md:pb-16 lg:pt-24 dark:bg-none dark:bg-gray-950"><div className="relative z-10 mx-auto w-full max-w-[1290px] px-[15px]">{t19}{t24}{t25}</div></section>;
    $[40] = t19;
    $[41] = t24;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  return t26;
}